var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.texts.length > 0)?_c('div',{staticClass:"ol-unselectable ol-control value",class:{pointer: _vm.texts.length > 1},on:{"click":_vm.toggle}},[_vm._v(" "+_vm._s(_vm.current)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }